import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IGroup, IGroupDAO, IGroupDetailDAO, IGroupUser, IGroupUserDAO } from 'types/domain/group';
import { IEntityReducer } from 'core/reducers/entities';
import { ITagJoin } from 'types/domain/tag';
import { getEntities } from '../utils/getEntities';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => (id ? id : state.state[EntityTypes.GROUP]);

export const selectGroup = createSelector([entity, id], parseGroup);

export function parseGroup(entity, id) {
  const group: IGroup = entity[EntityTypes.GROUP][id];

  if (!group) return null;

  return {
    ...group,
    text: group.textId ? entity[EntityTypes.TEXT][group.textId] : null,
    //tags: Object.values(entity[EntityTypes.TAG_JOIN]).filter((tj: ITagJoin) => tj.groupId === group.id),
    roleConfig: group.roleConfigId ? entity[EntityTypes.ROLE_CONFIG][group.roleConfigId] : null,
    permissions: getEntities(entity, EntityTypes.PERMISSION, 'groupId', id),
    groupUsers: getEntities(entity, EntityTypes.GROUP_USER, 'groupId', id).map((groupUser: IGroupUser) => {
      return {
        ...groupUser,
        organisationUser: entity[EntityTypes.ORG_USER][groupUser.organisationUserId],
      } as IGroupUserDAO;
    }),
  } as IGroupDetailDAO;
}